<ng-container *transloco="let t; read: 'findMyAgent.whyareyouhere'">
  <label id="whyareyouhere-label" class="mb-6 block text-steel-100 text-heading-2">{{ t('title') }}</label>
  <rma-group-select aria-labelledby="whyareyouhere-label" class="grid grid-cols-1 gap-4 md:grid-cols-3" [formControl]="control">
    @for (option of options; track option; let i = $index) {
      <rma-group-select-option #optionItem [tabindex]="i + 1" [option]="option" [optionTemplate]="optionTemplate">
        <ng-template #optionTemplate>
          <div
            class="flex flex-col items-center justify-center bg-blue-10 p-4 font-bold text-blue-100 hover:bg-blue-50 hover:text-blue-10 focus:border focus:border-blue-100 active:bg-blue-100 active:text-blue-10"
            [attr.data-id]="'property-type-' + option.label"
            [class.bg-blue-100]="optionItem.selected"
            [class.text-blue-10]="optionItem.selected"
          >
            <rma-icon [glyph]="option.icon" />
            {{ t('option.' + option.label) }}
          </div>
        </ng-template>
      </rma-group-select-option>
    }
  </rma-group-select>
</ng-container>
